document.addEventListener("DOMContentLoaded", function () {
  console.log("JS is Loaded");
  // Listen for the "Add to Cart" button click
  const quantityInputs = document.querySelectorAll(".quantity-input");
  const pdpPrice = document.querySelector(".product-container"); // Use querySelector for a single element

  function updateGrandTotal() {
    let grandTotal = 0;
    const totalPriceElements = document.querySelectorAll(".total-price");

    totalPriceElements.forEach((element) => {
      const priceText = element.innerText
        .replace("€", "")
        .replace(".", "")
        .replace(",", ".");
      grandTotal += parseFloat(priceText) || 0;
    });

    const grandTotalElement = document.getElementById("grand-total");
    const formattedGrandTotal = `€${grandTotal.toLocaleString("de-DE", {
      minimumFractionDigits: 2,
    })}`;
    grandTotalElement.innerText = formattedGrandTotal;
    if(pdpPrice){
      pdpPrice.innerText = formattedGrandTotal;
    }
    
  }

  quantityInputs.forEach((input) => {
    input.addEventListener("input", function () {
      const price = parseFloat(input.getAttribute("data-price"));
      const targetId = input.getAttribute("data-target");
      const qtyTargetId = input.getAttribute("data-qty-target");
      const quantity = parseInt(input.value, 10) || 0;
      

      // Update the total price for this row
      const totalPrice = (price * quantity) / 100; // Assuming prices are in cents
      const totalPriceElement = document.getElementById(targetId);

      if (totalPriceElement) {
        const formattedPrice = `€${totalPrice.toLocaleString("de-DE", {
          minimumFractionDigits: 2,
        })}`;
        totalPriceElement.innerText = formattedPrice;
      }

      // Update the quantity in the span
      const qtyElement = document.getElementById(qtyTargetId);
      if (qtyElement) {
        qtyElement.innerText = `${quantity}`;
      }

      // Update grand total
      updateGrandTotal();
    });
  });

  // Initial grand total calculation
  updateGrandTotal();
  var addToCartButton = document.getElementById("add_to_cart_btn");

  if (addToCartButton) {
    addToCartButton.addEventListener("click", function (event) {
      console.log("Add to Cart Button Clicked");
      event.preventDefault(); // Prevent default action (prevent the form submission)
      addRelatedProductsToCart();
    });
  }

  // Function to add related products to the cart
  function addRelatedProductsToCart() {
    let data = { items: [] };
    // Get all the related product divs
    document
      .querySelectorAll(".related-product")
      .forEach(function (relatedProductDiv) {
        console.log("Related Product Div", relatedProductDiv);
        var variantId = relatedProductDiv.getAttribute("data-variant-id");
        console.log("Variant Id", variantId);
        // var quantity = relatedProductDiv.querySelector('input[name="quantity"]').value || 1;
        // var quantity = relatedProductDiv.getAttribute('data-quantity').value || 1;
        // console.log("Qunatity", quantity);

        var quantityInput = relatedProductDiv.querySelector(
          'input[name="quantity"]'
        );
        var quantity = quantityInput ? quantityInput.value : 1; // Default to 1 if input is not found
        console.log("Quantity", quantity);
        // Call the Shopify AJAX API to add related products to the cart
        // data = {
        //   items: [{
        //     id: variantId,
        //     quantity: parseInt(quantity)
        //   }]
        // };
        data.items.push({
          id: variantId,
          quantity: parseInt(quantity),
        });

        console.log("Data", data);
      });
    // Add related product to cart via AJAX
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((cart) => {
        // Optionally, update the cart UI or show a success message
        console.log("Related product added to cart:", cart);
        window.location.href = "/cart";
      })
      .catch((error) => {
        console.error("Error adding related product to cart:", error);
      });
  }
});
